import moment from "moment";

/** Format API lifecycle timestamps for display. */
export const formatLifecycleDate = (value) => {
  if (!value) return "—";
  const m = moment(value);
  return m.isValid() ? m.format("YYYY-MM-DD") : "—";
};

/** Prefer lifecycle field, then fall back to older timestamp fields. */
export const getSubmissionDate = (app) =>
  app?.submissionDate || app?.submitted_at || app?.updated_at || app?.created_at || null;

export const getApprovalDate = (app) =>
  app?.approvalDate || app?.approved_at || null;

export const getRejectionDate = (app) =>
  app?.rejectionDate || app?.rejected_at || null;

/**
 * Build lifecycle date-range query params for GET /applications.
 * kind: "submitted" | "approved" | "rejected"
 */
export const buildLifecycleDateParams = (kind, startDate, endDate) => {
  const params = {};
  if (!startDate && !endDate) return params;

  const fromKey =
    kind === "approved"
      ? "approvedFrom"
      : kind === "rejected"
        ? "rejectedFrom"
        : "submittedFrom";
  const toKey =
    kind === "approved"
      ? "approvedTo"
      : kind === "rejected"
        ? "rejectedTo"
        : "submittedTo";

  if (startDate) params[fromKey] = moment(startDate).format("YYYY-MM-DD");
  if (endDate) params[toKey] = moment(endDate).format("YYYY-MM-DD");
  return params;
};
